import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { RequireAdmin } from "./components/admin/RequireAdmin";
import Home from "./pages/Home";
import CarDetail from "./pages/CarDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCarEdit from "./pages/AdminCarEdit";

const SiteLayout = () => (
  <>
    <div className="grain" aria-hidden="true" />
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/auto/:id" element={<CarDetail />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/auto/:id" element={<RequireAdmin><AdminCarEdit /></RequireAdmin>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </I18nProvider>
  );
}

export default App;
